import React from 'react'
import ViewTrainerAttendance from '../commonfile/ViewTrainerAttendance'

const AdminViewTrainerAtd = () => {
  return (
    <>

      <ViewTrainerAttendance />
    </>
  )
}

export default AdminViewTrainerAtd